import Offer from './Offer'
import AdditionalBookingType from './AdditionalBookingType';

export default class BookingType {

    id: string
    name: string
    description: string | null
    isValid: boolean
    unavailableMsg: string | null
    offers: Offer[] = []
    linkedTypes: []
    isLinkedType: boolean
    hidden: boolean

    private offerIds: string[] = []

    constructor (data: any) {
        this.id = data.value.id
        this.name = data.value.name
        this.description = data.value.description || null
        this.isValid = !!data.valid
        this.unavailableMsg = data.message || null
        this.offerIds = data.offers || []
        this.isLinkedType = data.value.isLinkedType || false
        this.hidden = data.hidden || false

        const uniqueIds = new Set();

        this.linkedTypes = data.value.availableLinkedTypes.map((linkedTypeList: []) => {
          return linkedTypeList
              .filter((linkedTypeData: {
                  id: any;
                  name: any;
                  isValid: any;
                  startTime: any;
                  duration: any;
                  selectable: any
              }) => {
                  const {id} = linkedTypeData;
                  // Check if the ID is already in the set
                  if (!uniqueIds.has(id)) {
                      // If not, add it to the set and include this item in the result
                      uniqueIds.add(id);
                      return true;
                  }

                  // If the ID is already in the set, exclude this item from the result
                  return false;
              })
              .map((linkedTypeData: object) => {
                  return new AdditionalBookingType(linkedTypeData)
              })
        });
    }

    fillOffers (offers: Offer[]): this {
        this.offers = offers.filter((offer) => {
            return this.offerIds.indexOf(offer.id) > -1
        })

        return this
    }
}



// WEBPACK FOOTER //
// ./src/models/BookingType.ts